/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utilities.
 */
const lazyMessages: Record<
	string,
	(() => Promise<{ default: Record<string, string> }>) | undefined
> = {
	cs: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/cs" */ './cs'),
	da: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/da" */ './da'),
	de: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/de" */ './de'),
	en: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/en" */ './en'),
	en_GB: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/en_GB" */ './en_GB'
		),
	en_ZZ: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/en_ZZ" */ './en_ZZ'
		),
	es: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/es" */ './es'),
	fi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/fi" */ './fi'),
	fr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/fr" */ './fr'),
	hu: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/hu" */ './hu'),
	it: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/it" */ './it'),
	ja: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/ja" */ './ja'),
	ko: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/ko" */ './ko'),
	nb: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/nb" */ './nb'),
	nl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/nl" */ './nl'),
	pl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/pl" */ './pl'),
	pt_BR: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/pt_BR" */ './pt_BR'
		),
	ru: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/ru" */ './ru'),
	sv: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/sv" */ './sv'),
	th: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/th" */ './th'),
	tr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/tr" */ './tr'),
	uk: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/uk" */ './uk'),
	vi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/vi" */ './vi'),
	zh: () =>
		import(/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/zh" */ './zh'),
	zh_TW: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_proforma-form-renderer/locale/zh_TW" */ './zh_TW'
		),
};
export default lazyMessages;
